import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import styled from "styled-components";

import ActionButton from "../components/ActionButton";
import CompleteTheLook from "../components/CompleteTheLook";
import Error from "../components/Error";
import Loading from "../components/Loading";
import ProductCarousel from "../components/ProductCarousel";
import ProductImages from "../components/ProductImages";
import SizeChart from "../components/SizeChart";
import { useCartContext } from "../context/CartContext";
import { useProductsContext } from "../context/ProductsContext";
import { useRecommendationContext } from "../context/RecommendationContext";
import { formatPrice } from "../utils/helpers";

const ProductDetailPage = () => {
  const { id } = useParams<{ id?: string }>();

  const { addToCart } = useCartContext();
  const {
    singleProductLoading,
    singleProductError,
    singleProduct,
    fetchSingleProduct,
  } = useProductsContext();

  const { styleRecommendations, getStyleRecommendation } =
    useRecommendationContext();

  useEffect(() => {
    getStyleRecommendation([+id!]);
    //eslint-disable-next-line
  }, [id]);

  useEffect(() => {
    fetchSingleProduct(+id!);
    //eslint-disable-next-line
  }, [id]);

  if (singleProductLoading) {
    return <Loading />;
  }
  if (singleProductError) {
    return <Error />;
  }

  const { brand, name, price, category, image_url } = singleProduct;

  const sizes =
    category === "Shoes"
      ? [5, 5.5, 6, 6.5, 7, 7.5, 8, 8.5, 9, 9.5, 10, 10.5, 11, 11.5, 12]
      : ["XS", "S", "M", "L", "XL"];

  return (
    <Wrapper>
      <div className="section section-center page">
        <div className="product-center">
          <ProductImages images={[image_url]} />
          <ProductInfo>
            <Name>{`${brand} ${name}`}</Name>
            <p className="price">{formatPrice(+price)}</p>
            <SizeChart sizes={sizes} numPerRow={5} />
            <ActionButton
              width={510}
              height={76}
              color={"#000"}
              label="Add to Bag"
              onClick={() =>
                addToCart(+id!, brand, name, +price, 1, category, image_url)
              }
            />
          </ProductInfo>
        </div>
        <CompleteTheLook
          className={"outfitRec"}
          title={"Complete the Look"}
          recommendations={styleRecommendations}
        />
        <ProductCarousel
          className={"productRec"}
          title={"You Might Also Like"}
        />
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.main`
  font-family: HelveticaNeue-Medium;

  .product-center {
    display: grid;
    margin-top: 2rem;
    margin-bottom: 4rem;
  }

  .price {
    font-size: 24px;
    color: #090a0a;
    margin-bottom: 4rem;
  }

  .outfitRec {
    padding-bottom: 50px;
  }

  .productRec {
    padding-bottom: 50px;
  }

  @media (min-width: 992px) {
    .product-center {
      grid-template-columns: 1fr 1fr;
    }
  }
`;

const ProductInfo = styled.section``;

const Name = styled.span`
  font-size: 32px;
`;

export default ProductDetailPage;
